import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faGasPumpSlash } from '@fortawesome/pro-light-svg-icons';
import { CreNgModule, SpinnerModule } from 'cre-ng';
import { ChartModule } from 'primeng/chart';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { WigFleetCompetitionTrendComponent } from './wig-fleet-competition-trend.component';

@NgModule({
  declarations: [WigFleetCompetitionTrendComponent],
  exports: [WigFleetCompetitionTrendComponent],
  imports: [
    ChartModule,
    CommonModule,
    CoreModule,
    CreNgModule,
    FontAwesomeModule,
    SharedModule,
    SpinnerModule,
  ],
  providers: [],
})
export class WigFleetCompetitionTrendModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faGasPumpSlash);
  }
}
